<template>
  <div class="p-[20px] pt-[20px]">
    <div
      class="h-[auto] bg-[white] rounded-[12px] pt-[28px] pl-[28px] pr-[28px] flex flex-col justify-end"
    >
      <div>
        <div class="flex justify-between">
          <div class="flex">
            <div>
              <svg
                width="41"
                height="41"
                viewBox="0 0 41 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_1318_23015"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="41"
                  height="41"
                >
                  <rect width="41" height="41" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1318_23015)">
                  <path
                    d="M10.2513 36.7288C9.05765 36.7288 8.04744 36.3154 7.22063 35.4886C6.39386 34.6618 5.98047 33.6516 5.98047 32.458V30.6182C5.98047 29.769 6.28286 29.042 6.88764 28.4372C7.49239 27.8325 8.21938 27.5301 9.06862 27.5301H11.1055V7.35866C11.1055 6.50942 11.4079 5.78243 12.0126 5.17768C12.6174 4.5729 13.3444 4.27051 14.1936 4.27051H31.9339C32.7831 4.27051 33.5101 4.5729 34.1149 5.17768C34.7197 5.78243 35.0221 6.50942 35.0221 7.35866V32.458C35.0221 33.6516 34.6087 34.6618 33.7819 35.4886C32.9551 36.3154 31.9449 36.7288 30.7513 36.7288H10.2513ZM30.7513 34.1663C31.2353 34.1663 31.641 34.0026 31.9684 33.6752C32.2959 33.3477 32.4596 32.942 32.4596 32.458V7.35866C32.4596 7.20534 32.4103 7.07939 32.3117 6.98082C32.2132 6.88225 32.0872 6.83297 31.9339 6.83297H14.1936C14.0403 6.83297 13.9144 6.88225 13.8158 6.98082C13.7172 7.07939 13.6679 7.20534 13.6679 7.35866V27.5301H25.9548C26.8041 27.5301 27.5311 27.8325 28.1358 28.4372C28.7406 29.042 29.0429 29.769 29.0429 30.6182V32.458C29.0429 32.942 29.2066 33.3477 29.5341 33.6752C29.8615 34.0026 30.2672 34.1663 30.7513 34.1663ZM16.986 14.8489C16.623 14.8489 16.3187 14.7261 16.0732 14.4804C15.8276 14.2348 15.7048 13.9303 15.7048 13.5672C15.7048 13.204 15.8276 12.8997 16.0732 12.6545C16.3187 12.4092 16.623 12.2865 16.986 12.2865H29.1415C29.5045 12.2865 29.8088 12.4094 30.0543 12.6551C30.2999 12.9007 30.4227 13.2051 30.4227 13.5683C30.4227 13.9315 30.2999 14.2357 30.0543 14.481C29.8088 14.7263 29.5045 14.8489 29.1415 14.8489H16.986ZM16.986 19.7768C16.623 19.7768 16.3187 19.654 16.0732 19.4083C15.8276 19.1626 15.7048 18.8582 15.7048 18.495C15.7048 18.1318 15.8276 17.8276 16.0732 17.5823C16.3187 17.337 16.623 17.2144 16.986 17.2144H29.1415C29.5045 17.2144 29.8088 17.3372 30.0543 17.5829C30.2999 17.8286 30.4227 18.133 30.4227 18.4962C30.4227 18.8594 30.2999 19.1636 30.0543 19.4089C29.8088 19.6542 29.5045 19.7768 29.1415 19.7768H16.986ZM10.2513 34.1663H26.4805V30.6182C26.4805 30.4649 26.4312 30.339 26.3327 30.2404C26.2341 30.1418 26.1081 30.0925 25.9548 30.0925H9.06862C8.9153 30.0925 8.78935 30.1418 8.69078 30.2404C8.59221 30.339 8.54293 30.4649 8.54293 30.6182V32.458C8.54293 32.942 8.70664 33.3477 9.03407 33.6752C9.3615 34.0026 9.76723 34.1663 10.2513 34.1663ZM10.2513 34.1663H8.54293H26.4805H10.2513Z"
                    fill="#003765"
                  />
                </g>
              </svg>
            </div>
            <div
              class="text-[24px] font-bold ml-[8px] flex justify-center items-center"
            >
              การจัดการสัญญาเช่า
            </div>
          </div>
          <!-- <div class="flex border pl-[14px] pr-[14px]  rounded-[12px] cursor-pointer ">
                        <div class="flex justify-center items-center">
                            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3845 18.2081H7.60814C7.40247 18.2081 7.22442 18.1391 7.074 18.001C6.92357 17.8629 6.83308 17.691 6.80253 17.4854L6.53635 15.4158C6.29073 15.3336 6.03894 15.2184 5.78097 15.0703C5.52301 14.9222 5.29236 14.7636 5.08905 14.5943L3.17464 15.4017C2.97838 15.4781 2.78359 15.4857 2.59026 15.4246C2.39693 15.3635 2.24504 15.2425 2.13456 15.0615L0.756079 12.6606C0.645605 12.4796 0.611818 12.2863 0.654718 12.0806C0.697603 11.8749 0.801897 11.7092 0.967599 11.5835L2.62466 10.3301C2.6035 10.1938 2.58851 10.0569 2.5797 9.91937C2.57088 9.78187 2.56647 9.64496 2.56647 9.50864C2.56647 9.37818 2.57088 9.24567 2.5797 9.1111C2.58851 8.97654 2.6035 8.82934 2.62466 8.66952L0.967599 7.41614C0.801897 7.2904 0.697603 7.1247 0.654718 6.91903C0.611818 6.71338 0.645605 6.52006 0.756079 6.33908L2.13456 3.95579C2.23564 3.7654 2.38372 3.642 2.5788 3.5856C2.77388 3.52919 2.96955 3.53918 3.16581 3.61557L5.08022 4.41413C5.30117 4.23901 5.5371 4.07889 5.78801 3.93375C6.03893 3.78859 6.28544 3.67195 6.52753 3.58381L6.80253 1.51427C6.83308 1.3086 6.92357 1.13673 7.074 0.998647C7.22442 0.860552 7.40247 0.791504 7.60814 0.791504H10.3845C10.5902 0.791504 10.7697 0.860552 10.9231 0.998647C11.0764 1.13673 11.1684 1.3086 11.199 1.51427L11.4651 3.59263C11.7401 3.69252 11.989 3.80916 12.2117 3.94255C12.4344 4.07594 12.6592 4.23313 12.886 4.41413L14.8357 3.61557C15.0319 3.53918 15.2252 3.53007 15.4156 3.58823C15.606 3.64641 15.7564 3.76599 15.8669 3.94697L17.2454 6.33908C17.3559 6.52006 17.3897 6.71338 17.3468 6.91903C17.3039 7.1247 17.1996 7.2904 17.0339 7.41614L15.3416 8.69594C15.3745 8.84403 15.3924 8.98242 15.3953 9.1111C15.3983 9.23979 15.3997 9.36936 15.3997 9.49981C15.3997 9.62439 15.3968 9.75102 15.3909 9.87971C15.3851 10.0084 15.3639 10.1556 15.3275 10.3213L17.0021 11.5835C17.1737 11.7034 17.2795 11.8676 17.3194 12.0762C17.3594 12.2848 17.3242 12.4796 17.2137 12.6606L15.8352 15.0474C15.7247 15.2283 15.5705 15.3503 15.3724 15.4132C15.1744 15.476 14.9773 15.4693 14.781 15.3929L12.886 14.5855C12.6592 14.7665 12.4277 14.9266 12.1914 15.0659C11.9552 15.2052 11.7131 15.3189 11.4651 15.407L11.199 17.4854C11.1684 17.691 11.0764 17.8629 10.9231 18.001C10.7697 18.1391 10.5902 18.2081 10.3845 18.2081ZM9.0113 12.2498C9.77402 12.2498 10.423 11.9821 10.9583 11.4468C11.4936 10.9115 11.7613 10.2625 11.7613 9.49981C11.7613 8.73712 11.4936 8.08811 10.9583 7.55279C10.423 7.01749 9.77402 6.74984 9.0113 6.74984C8.23921 6.74984 7.58786 7.01749 7.05725 7.55279C6.52665 8.08811 6.26135 8.73712 6.26135 9.49981C6.26135 10.2625 6.52665 10.9115 7.05725 11.4468C7.58786 11.9821 8.23921 12.2498 9.0113 12.2498ZM9.0113 10.8748C8.62936 10.8748 8.30471 10.7411 8.03735 10.4738C7.76999 10.2064 7.6363 9.88176 7.6363 9.49981C7.6363 9.11787 7.76999 8.79322 8.03735 8.52586C8.30471 8.2585 8.62936 8.12482 9.0113 8.12482C9.39325 8.12482 9.7179 8.2585 9.98526 8.52586C10.2526 8.79322 10.3863 9.11787 10.3863 9.49981C10.3863 9.88176 10.2526 10.2064 9.98526 10.4738C9.7179 10.7411 9.39325 10.8748 9.0113 10.8748ZM8.08407 16.8332H9.88567L10.2153 14.3775C10.6831 14.2553 11.1105 14.0817 11.4978 13.8566C11.885 13.6316 12.2584 13.3422 12.618 12.9884L14.8956 13.9457L15.7982 12.3873L13.8097 10.8889C13.8861 10.6515 13.9381 10.4188 13.9657 10.1908C13.9933 9.96285 14.0071 9.73251 14.0071 9.49981C14.0071 9.26125 13.9933 9.03091 13.9657 8.80879C13.9381 8.58668 13.8861 8.35986 13.8097 8.12834L15.8158 6.61232L14.9132 5.05398L12.6092 6.0253C12.3025 5.69741 11.935 5.40772 11.5066 5.15624C11.0782 4.90473 10.6449 4.72669 10.2065 4.62209L9.91741 2.16648H8.09817L7.79498 4.61327C7.32723 4.72374 6.89534 4.89298 6.49929 5.12097C6.10325 5.34896 5.72542 5.64276 5.36581 6.00239L3.08824 5.05398L2.18567 6.61232L4.16532 8.08781C4.08893 8.30521 4.03546 8.53143 4.00491 8.76648C3.97435 9.00153 3.95907 9.24892 3.95907 9.50864C3.95907 9.7472 3.97435 9.98107 4.00491 10.2102C4.03546 10.4394 4.08599 10.6656 4.1565 10.8889L2.18567 12.3873L3.08824 13.9457L5.35699 12.9831C5.70485 13.3404 6.0768 13.6331 6.47285 13.861C6.86889 14.089 7.30666 14.2641 7.78616 14.3864L8.08407 16.8332Z"
                                    fill="#003765" />
                            </svg>
                        </div>
                        <div class="text-[14px] font-bold ml-[8px] flex justify-center items-center">ตั้งค่าผังห้อง</div>
                    </div> -->
        </div>
        <div class="flex">
          <!-- <div class="h-[36px] pr-[10px] pl-[8px] bg-[#003765] flex cursor-pointer  justify-center rounded-[12px] mt-[12px]"
                        @click="detail = true">
                        <div class="flex justify-center items-center">
                            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_3392_6175" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                    width="22" height="23">
                                    <rect y="0.5" width="22" height="22" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_3392_6175)">
                                    <path
                                        d="M11 14.469C10.8895 14.469 10.7867 14.4514 10.6915 14.4161C10.5963 14.3809 10.5058 14.3203 10.42 14.2345L7.56956 11.3841C7.44265 11.2572 7.37772 11.0976 7.37479 10.9055C7.37184 10.7134 7.43676 10.5509 7.56956 10.4181C7.70235 10.2853 7.8657 10.2166 8.05961 10.2118C8.25351 10.2071 8.41687 10.2712 8.54968 10.404L10.3125 12.1668V5.15427C10.3125 4.95919 10.3783 4.79584 10.5099 4.66422C10.6415 4.53261 10.8049 4.4668 11 4.4668C11.1951 4.4668 11.3584 4.53261 11.49 4.66422C11.6216 4.79584 11.6875 4.95919 11.6875 5.15427V12.1668L13.4503 10.404C13.5772 10.2771 13.7391 10.2145 13.9359 10.2162C14.1328 10.218 14.2976 10.2853 14.4304 10.4181C14.5632 10.5509 14.6296 10.7119 14.6296 10.9011C14.6296 11.0903 14.5632 11.2513 14.4304 11.3841L11.5799 14.2345C11.4941 14.3203 11.4037 14.3809 11.3085 14.4161C11.2133 14.4514 11.1105 14.469 11 14.469ZM5.78206 18.3754C5.31902 18.3754 4.92708 18.215 4.60625 17.8942C4.28542 17.5733 4.125 17.1814 4.125 16.7183V14.9379C4.125 14.7428 4.19082 14.5795 4.32245 14.4479C4.45407 14.3162 4.61742 14.2504 4.8125 14.2504C5.00758 14.2504 5.17093 14.3162 5.30255 14.4479C5.43417 14.5795 5.49998 14.7428 5.49998 14.9379V16.7183C5.49998 16.7889 5.52936 16.8535 5.58811 16.9123C5.64689 16.971 5.71154 17.0004 5.78206 17.0004H16.2179C16.2884 17.0004 16.3531 16.971 16.4118 16.9123C16.4706 16.8535 16.5 16.7889 16.5 16.7183V14.9379C16.5 14.7428 16.5658 14.5795 16.6974 14.4479C16.829 14.3162 16.9924 14.2504 17.1875 14.2504C17.3825 14.2504 17.5459 14.3162 17.6775 14.4479C17.8091 14.5795 17.875 14.7428 17.875 14.9379V16.7183C17.875 17.1814 17.7145 17.5733 17.3937 17.8942C17.0729 18.215 16.6809 18.3754 16.2179 18.3754H5.78206Z"
                                        fill="white" />
                                </g>
                            </svg>
                        </div>
                        <div @click="detail = true"
                            class="text-white font-bold ml-[8px]   flex justify-center items-center">ดาวน์โหลดสัญญาเช่า
                        </div>
                    </div> -->
          <div class="flex justify-start items-center mt-[5px] ml-[14px]">
            <input
              class="h-[36px] w-[250px] bg-[#F3F7FA] rounded-[12px]"
              placeholder="ค้นหาตามหมายเลขห้อง"
              v-model="filter.search"
              @input="filterData"
              type="input"
              @keydown="handleKeyDown"
            />
          </div>
          <vs-tooltip bottom shadow not-hover v-model="popup_filter">
            <div
              @click="popup_filter = true"
              class="h-[36px] w-[132px] flex justify-center rounded-[12px] mt-[12px] ml-[14px] cursor-pointer"
            >
              <div class="flex justify-center items-center">
                <svg
                  width="22"
                  height="23"
                  viewBox="0 0 22 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_3262_4178"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="22"
                    height="23"
                  >
                    <rect y="0.5" width="22" height="22" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_3262_4178)">
                    <path
                      d="M10.0846 16.7707C9.88982 16.7707 9.72655 16.7048 9.59479 16.573C9.46302 16.4411 9.39714 16.2778 9.39714 16.0829C9.39714 15.888 9.46302 15.7248 9.59479 15.5932C9.72655 15.4615 9.88982 15.3957 10.0846 15.3957H11.9179C12.1127 15.3957 12.276 15.4616 12.4078 15.5935C12.5395 15.7253 12.6054 15.8886 12.6054 16.0835C12.6054 16.2784 12.5395 16.4416 12.4078 16.5733C12.276 16.7049 12.1127 16.7707 11.9179 16.7707H10.0846ZM3.66795 7.25144C3.47315 7.25144 3.30988 7.18553 3.17813 7.05369C3.04635 6.92186 2.98047 6.75851 2.98047 6.56364C2.98047 6.36876 3.04635 6.20551 3.17813 6.07389C3.30988 5.94227 3.47315 5.87646 3.66795 5.87646H18.3346C18.5294 5.87646 18.6927 5.94238 18.8245 6.07421C18.9562 6.20603 19.0221 6.36938 19.0221 6.56426C19.0221 6.75913 18.9562 6.92237 18.8245 7.05399C18.6927 7.18563 18.5294 7.25144 18.3346 7.25144H3.66795ZM6.41795 12.0111C6.22315 12.0111 6.05988 11.9451 5.92813 11.8133C5.79635 11.6815 5.73047 11.5181 5.73047 11.3233C5.73047 11.1284 5.79635 10.9651 5.92813 10.8335C6.05988 10.7019 6.22315 10.6361 6.41795 10.6361H15.5846C15.7794 10.6361 15.9427 10.702 16.0745 10.8338C16.2062 10.9657 16.2721 11.129 16.2721 11.3239C16.2721 11.5188 16.2062 11.682 16.0745 11.8136C15.9427 11.9452 15.7794 12.0111 15.5846 12.0111H6.41795Z"
                      fill="#003765"
                    />
                  </g>
                </svg>
              </div>
              <div class="font-bold ml-[8px] flex justify-center items-center">
                ฟิลเตอร์
              </div>
            </div>
            <template #tooltip>
              <div class="w-[100%]">
                <div class="center">
                  <vs-checkbox
                    v-model="filter.select"
                    val="Reserved"
                    @input="getRentalContract()"
                  >
                    <div class="text-custom">ห้องจอง</div>
                  </vs-checkbox>
                </div>
                <div class="center">
                  <vs-checkbox
                    v-model="filter.select"
                    val="Checked In"
                    @input="getRentalContract()"
                  >
                    <div class="text-custom">ห้องมีผู้เข้าพัก</div>
                  </vs-checkbox>
                </div>
                <div class="center">
                  <vs-checkbox
                    v-model="filter.select"
                    val="Available"
                    @input="getRentalContract()"
                  >
                    <div class="text-custom">ห้องว่าง</div>
                  </vs-checkbox>
                </div>
                <div class="center">
                  <vs-checkbox
                    v-model="filter.select"
                    val="Maintenance"
                    @input="getRentalContract()"
                  >
                    <div class="text-custom">ห้องรอดำเนินการ</div>
                  </vs-checkbox>
                </div>
              </div>
            </template>
          </vs-tooltip>
        </div>
      </div>

      <!-- 
            <div class="flex items-center mb-[8px] mt-[14px] table-container">
                <div v-for="(data, i) in roomFloor" class="flex-initial flex-nowrap w-32 p-2 border-1"
                :class="tab_floor == i ? 'font-bold text-[16px] text-[white] bg-[#003765]' : 'text-[#8396A6]'">
                    <div class="cursor-pointer whitespace-nowrap"
                        :class="tab_floor == i ? 'font-bold text-[16px]' : 'text-[#8396A6]'"
                        @click="tab_floor = i, filter.floor = data.id, getRoom(), name_floor = data.attributes.floorName">
                        ชั้น {{ data.attributes.floorName }}
                    </div>
                </div>
            </div> -->

      <div class="flex items-center mb-[8px] mt-[14px] table-container">
        <div
          v-for="(data, i) in roomFloor"
          class="flex-initial flex-nowrap w-32 p-2 border-1"
          :class="
            tab_floor == i
              ? 'font-bold text-[16px] text-[white] bg-[#003765]'
              : 'text-[#8396A6]'
          "
        >
          <div
            class="cursor-pointer mr-[8px] whitespace-nowrap"
            :class="tab_floor == i ? 'font-bold text-[16px]' : 'text-[#8396A6]'"
            @click="selectFloor(data, i)"
          >
            ชั้น {{ data.attributes.floorName }}
          </div>
        </div>
      </div>
    </div>

    <!-- //////////////////////////// card /////////////////////// -->
    <div class="mt-[24px]">
      <div class="text-[24px] font-bold">
        ชั้น {{ name_floor }} ({{ contract.length }})
      </div>
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-[100%] gap-4 mt-[14px]"
      >
        <!-- //////////////////////////// Loop Room Contract /////////////////////// -->
        <div
          class="bg-[white] rounded-[16px] flex justify-between p-[14px] h-[160px] cursor-pointer"
          v-for="data in contract"
        >
          <div class="flex flex-col justify-between">
            <div class="ml-[14px]">
              <div class="text-[24px] font-bold text-[#141629]">
                ห้อง {{ data.RoomNumber }}
              </div>
              <div class="text-[18px] mt-[12px] font-bold text-[#003765]">
                {{
                  data.user_sign_contract &&
                  data.user_sign_contract.users_permissions_user
                    ? data.user_sign_contract.users_permissions_user.firstName
                    : ""
                }}
                {{
                  data.user_sign_contract &&
                  data.user_sign_contract.users_permissions_user
                    ? data.user_sign_contract.users_permissions_user.lastName
                    : ""
                }}
              </div>
            </div>
            <div class="ml-[14px]">
              <div class="flex">
                <div
                  class="h-[32px] pr-[8px] pl-[8px] cursor-pointer rounded-[12px]"
                  :class="
                    data.roomStatus == 'Checked In'
                      ? 'bg-[#003765]'
                      : 'bg-[#165D98]'
                  "
                  @click="
                    data.roomStatus == 'Checked In'
                      ? (getDetailRentalContract(data.user_sign_contract.id),
                        (data_mock = data))
                      : data.roomStatus == 'Reserved'
                      ? (create_sign(
                          data.id,
                          data.RoomNumber,
                          'reserved',
                          data.user_sign_contract.users_permissions_user
                            ?.idCard,
                          data.room_type.id,
                          data.user_sign_contract
                        ),
                        (data_mock = data))
                      : (create_sign(data.id, data.RoomNumber),
                        (data_mock = data))
                  "
                >
                  <div class="flex items-center h-[100%]">
                    <div class="flex justify-center items-center">
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        v-if="data.user_sign_contract"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.58201 2.16697V7.83092V7.808V16.8336V2.16697ZM4.33201 11.1044H6.89693C7.01092 10.8412 7.14372 10.5965 7.29532 10.3703C7.44692 10.144 7.61732 9.93044 7.80652 9.72949H4.33201C4.13722 9.72949 3.97394 9.7954 3.84219 9.92722C3.71042 10.0591 3.64453 10.2224 3.64453 10.4173C3.64453 10.6122 3.71042 10.7754 3.84219 10.907C3.97394 11.0386 4.13722 11.1044 4.33201 11.1044ZM4.33201 14.7711H6.42272C6.36836 14.542 6.33303 14.3128 6.31673 14.0836C6.30043 13.8545 6.30168 13.6253 6.32049 13.3962H4.33201C4.13722 13.3962 3.97394 13.4621 3.84219 13.5939C3.71042 13.7257 3.64453 13.8891 3.64453 14.0839C3.64453 14.2788 3.71042 14.4421 3.84219 14.5737C3.97394 14.7053 4.13722 14.7711 4.33201 14.7711ZM1.86251 18.2086C1.40052 18.2086 1.00911 18.0482 0.688281 17.7274C0.367448 17.4065 0.207031 17.0146 0.207031 16.5516V2.44905C0.207031 1.98601 0.367448 1.59408 0.688281 1.27324C1.00911 0.952409 1.40105 0.791992 1.86409 0.791992H8.4588C8.68234 0.791992 8.89541 0.834893 9.09801 0.920693C9.30059 1.00648 9.47711 1.12458 9.62755 1.27501L13.474 5.12143C13.6244 5.27187 13.7425 5.44838 13.8283 5.65097C13.9141 5.85357 13.957 6.06664 13.957 6.29018V8.13413C13.7372 8.04717 13.5128 7.98106 13.2836 7.93581C13.0544 7.89057 12.8206 7.85561 12.582 7.83092V6.29195H9.28187C9.04812 6.29195 8.85221 6.21288 8.69415 6.05476C8.53607 5.89663 8.45703 5.7007 8.45703 5.46695V2.16697H1.86409C1.79357 2.16697 1.72892 2.19635 1.67015 2.25511C1.61139 2.31388 1.58201 2.37853 1.58201 2.44905V16.5516C1.58201 16.6221 1.61139 16.6867 1.67015 16.7455C1.72892 16.8043 1.79357 16.8336 1.86409 16.8336H7.2724C7.45136 17.1048 7.6527 17.3563 7.87641 17.5879C8.10011 17.8196 8.34241 18.0265 8.60331 18.2086H1.86251ZM12.1254 16.058C12.8071 16.058 13.3826 15.8227 13.8521 15.352C14.3216 14.8814 14.5564 14.3052 14.5564 13.6236C14.5564 12.9419 14.321 12.3663 13.8504 11.8969C13.3797 11.4274 12.8036 11.1926 12.1219 11.1926C11.4403 11.1926 10.8647 11.4279 10.3952 11.8986C9.92573 12.3692 9.69098 12.9454 9.69098 13.627C9.69098 14.3087 9.9263 14.8843 10.3969 15.3537C10.8676 15.8232 11.4438 16.058 12.1254 16.058ZM17.2823 18.7833C17.1558 18.9102 16.9948 18.9737 16.7993 18.9737C16.6038 18.9737 16.4426 18.9102 16.3157 18.7833L14.2884 16.7472C13.9793 16.9729 13.6406 17.1436 13.2721 17.2593C12.9037 17.3751 12.5209 17.433 12.1237 17.433C11.066 17.433 10.167 17.0628 9.42657 16.3224C8.68619 15.582 8.316 14.683 8.316 13.6253C8.316 12.5676 8.68619 11.6686 9.42657 10.9282C10.167 10.1878 11.066 9.81763 12.1237 9.81763C13.1814 9.81763 14.0804 10.1878 14.8208 10.9282C15.5612 11.6686 15.9313 12.5676 15.9313 13.6253C15.9313 14.0225 15.8735 14.4053 15.7577 14.7738C15.6419 15.1422 15.4713 15.481 15.2456 15.79L17.2817 17.8173C17.4086 17.9437 17.4721 18.1046 17.4721 18.2999C17.4721 18.4953 17.4088 18.6564 17.2823 18.7833Z"
                          fill="white"
                        />
                      </svg>
                      <svg
                        width="23"
                        height="23"
                        viewBox="0 0 23 23"
                        fill="none"
                        v-else
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_3507_6507"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="23"
                          height="23"
                        >
                          <rect
                            x="0.332031"
                            y="0.5"
                            width="22"
                            height="22"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_3507_6507)">
                          <path
                            d="M5.83071 20.2086C5.19023 20.2086 4.64817 19.9868 4.20452 19.5432C3.76088 19.0995 3.53906 18.5574 3.53906 17.917V16.9298C3.53906 16.4741 3.70132 16.084 4.02584 15.7595C4.35034 15.435 4.74043 15.2728 5.19612 15.2728H6.28906V4.44905C6.28906 3.99336 6.45132 3.60327 6.77584 3.27877C7.10034 2.95425 7.49043 2.79199 7.94612 2.79199H17.4653C17.921 2.79199 18.3111 2.95425 18.6356 3.27877C18.9601 3.60327 19.1224 3.99336 19.1224 4.44905V17.917C19.1224 18.5574 18.9005 19.0995 18.4569 19.5432C18.0132 19.9868 17.4712 20.2086 16.8307 20.2086H5.83071ZM16.8307 18.8336C17.0904 18.8336 17.3081 18.7458 17.4838 18.5701C17.6595 18.3944 17.7474 18.1767 17.7474 17.917V4.44905C17.7474 4.36678 17.7209 4.2992 17.668 4.24631C17.6151 4.19342 17.5476 4.16697 17.4653 4.16697H7.94612C7.86385 4.16697 7.79627 4.19342 7.74338 4.24631C7.69049 4.2992 7.66404 4.36678 7.66404 4.44905V15.2728H14.257C14.7127 15.2728 15.1028 15.435 15.4273 15.7595C15.7518 16.084 15.914 16.4741 15.914 16.9298V17.917C15.914 18.1767 16.0019 18.3944 16.1776 18.5701C16.3533 18.7458 16.571 18.8336 16.8307 18.8336ZM9.44448 8.46822C9.24969 8.46822 9.08642 8.40231 8.95466 8.2705C8.82289 8.13867 8.757 7.97532 8.757 7.78045C8.757 7.58556 8.82289 7.42231 8.95466 7.29069C9.08642 7.15908 9.24969 7.09327 9.44448 7.09327H15.9669C16.1617 7.09327 16.325 7.15918 16.4568 7.29102C16.5885 7.42283 16.6544 7.58618 16.6544 7.78107C16.6544 7.97593 16.5885 8.13918 16.4568 8.27079C16.325 8.40241 16.1617 8.46822 15.9669 8.46822H9.44448ZM9.44448 11.1125C9.24969 11.1125 9.08642 11.0465 8.95466 10.9147C8.82289 10.7829 8.757 10.6195 8.757 10.4247C8.757 10.2298 8.82289 10.0665 8.95466 9.93491C9.08642 9.80329 9.24969 9.73749 9.44448 9.73749H15.9669C16.1617 9.73749 16.325 9.8034 16.4568 9.93523C16.5885 10.067 16.6544 10.2304 16.6544 10.4253C16.6544 10.6202 16.5885 10.7834 16.4568 10.915C16.325 11.0467 16.1617 11.1125 15.9669 11.1125H9.44448ZM5.83071 18.8336H14.5391V16.9298C14.5391 16.8475 14.5126 16.7799 14.4597 16.727C14.4069 16.6742 14.3393 16.6477 14.257 16.6477H5.19612C5.11385 16.6477 5.04627 16.6742 4.99338 16.727C4.94049 16.7799 4.91404 16.8475 4.91404 16.9298V17.917C4.91404 18.1767 5.00189 18.3944 5.17758 18.5701C5.35328 18.7458 5.57098 18.8336 5.83071 18.8336ZM5.83071 18.8336H4.91404H14.5391H5.83071Z"
                            fill="white"
                          />
                        </g>
                      </svg>
                    </div>
                    <div
                      class="text-white font-bold ml-[4px] flex justify-center items-center"
                    >
                      {{
                        data.roomStatus == "Checked In"
                          ? "ดูสัญญาเช่า"
                          : "สร้างสัญญาเช่า"
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col justify-between">
            <div class="flex">
              <div class="flex justify-center items-center">
                <!-- <div v-if="data.user_sign_contract">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="12" fill="#FFE2E9" />
                                        <mask id="mask0_1490_34553" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="5"
                                            y="5" width="22" height="22">
                                            <rect x="5" y="5" width="22" height="22" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_1490_34553)">
                                            <path
                                                d="M11.0588 23C10.4834 23 9.99642 22.809 9.59784 22.4269C9.19928 22.0448 9 21.5779 9 21.0263V20.1761C9 19.7837 9.14577 19.4477 9.43732 19.1682C9.72885 18.8887 10.0793 18.749 10.4887 18.749H11.4706V9.42714C11.4706 9.03467 11.6164 8.69871 11.9079 8.41923C12.1994 8.13974 12.5499 8 12.9593 8H21.5113C21.9207 8 22.2712 8.13974 22.5627 8.41923C22.8542 8.69871 23 9.03467 23 9.42714V21.0263C23 21.5779 22.8007 22.0448 22.4022 22.4269C22.0036 22.809 21.5166 23 20.9412 23H11.0588ZM20.9412 21.8158C21.1745 21.8158 21.3701 21.7401 21.528 21.5888C21.6858 21.4375 21.7647 21.25 21.7647 21.0263V9.42714C21.7647 9.35628 21.741 9.29808 21.6934 9.25252C21.6459 9.20697 21.5852 9.18419 21.5113 9.18419H12.9593C12.8854 9.18419 12.8247 9.20697 12.7771 9.25252C12.7296 9.29808 12.7059 9.35628 12.7059 9.42714V18.749H18.629C19.0384 18.749 19.3888 18.8887 19.6804 19.1682C19.9719 19.4477 20.1177 19.7837 20.1177 20.1761V21.0263C20.1177 21.25 20.1966 21.4375 20.3544 21.5888C20.5123 21.7401 20.7079 21.8158 20.9412 21.8158ZM14.3054 12.8886C14.1304 12.8886 13.9837 12.8319 13.8654 12.7183C13.747 12.6048 13.6878 12.4641 13.6878 12.2963C13.6878 12.1284 13.747 11.9878 13.8654 11.8745C13.9837 11.7611 14.1304 11.7045 14.3054 11.7045H20.1652C20.3402 11.7045 20.4869 11.7612 20.6052 11.8748C20.7236 11.9883 20.7828 12.129 20.7828 12.2968C20.7828 12.4647 20.7236 12.6052 20.6052 12.7186C20.4869 12.832 20.3402 12.8886 20.1652 12.8886H14.3054ZM14.3054 15.166C14.1304 15.166 13.9837 15.1092 13.8654 14.9957C13.747 14.8821 13.6878 14.7414 13.6878 14.5736C13.6878 14.4058 13.747 14.2652 13.8654 14.1518C13.9837 14.0385 14.1304 13.9818 14.3054 13.9818H20.1652C20.3402 13.9818 20.4869 14.0385 20.6052 14.1521C20.7236 14.2656 20.7828 14.4063 20.7828 14.5741C20.7828 14.742 20.7236 14.8826 20.6052 14.9959C20.4869 15.1093 20.3402 15.166 20.1652 15.166H14.3054ZM11.0588 21.8158H18.8824V20.1761C18.8824 20.1053 18.8586 20.0471 18.8111 20.0015C18.7636 19.956 18.7029 19.9332 18.629 19.9332H10.4887C10.4148 19.9332 10.3541 19.956 10.3066 20.0015C10.259 20.0471 10.2353 20.1053 10.2353 20.1761V21.0263C10.2353 21.25 10.3142 21.4375 10.472 21.5888C10.6299 21.7401 10.8255 21.8158 11.0588 21.8158ZM11.0588 21.8158H10.2353H18.8824H11.0588Z"
                                                fill="#D44769" />
                                            <path
                                                d="M9.3409 14.1663C9.15585 14.1663 8.99743 14.1004 8.86565 13.9687C8.73386 13.8369 8.66797 13.6785 8.66797 13.4934C8.66797 13.3084 8.73386 13.1499 8.86565 13.0181C8.99743 12.8864 9.15585 12.8205 9.3409 12.8205C9.52596 12.8205 9.68438 12.8864 9.81616 13.0181C9.94795 13.1499 10.0138 13.3084 10.0138 13.4934C10.0138 13.6785 9.94795 13.8369 9.81616 13.9687C9.68438 14.1004 9.52596 14.1663 9.3409 14.1663ZM9.34022 11.9664C9.17158 11.9664 9.02745 11.9064 8.90782 11.7864C8.78818 11.6665 8.72837 11.5223 8.72837 11.3538V7.44554C8.72837 7.27709 8.78841 7.13289 8.9085 7.01293C9.02859 6.89298 9.17296 6.83301 9.34159 6.83301C9.51023 6.83301 9.65436 6.89298 9.77399 7.01293C9.89362 7.13289 9.95344 7.27709 9.95344 7.44554V11.3538C9.95344 11.5223 9.8934 11.6665 9.77331 11.7864C9.65321 11.9064 9.50885 11.9664 9.34022 11.9664Z"
                                                fill="#D44769" />
                                        </g>
                                    </svg>
                                </div> -->
              </div>
              <div
                :class="
                  data.roomStatus == 'Checked In'
                    ? 'text-[#0B9A3C] bg-[#CFFBDA]'
                    : 'text-[#003765] bg-[#F0F8FF]'
                "
                class="h-[36px] ml-[8px] w-[auto] flex items-center justify-center pl-[12px] pr-[12px] rounded-[12px] pb-[4px] pt-[4px]"
              >
                <!-- {{ data.user_sign_contract ? "มีผู้เข้าพัก" : "ห้องว่าง" }} -->
                {{
                  data.roomStatus == "Reserved"
                    ? "ห้องจอง"
                    : data.roomStatus == "Checked In"
                    ? "มีผู้เข้าพัก"
                    : data.roomStatus == "Maintenance"
                    ? "รอดำเนินการ"
                    : "ห้องว่าง"
                }}
              </div>
            </div>
            <div class="flex justify-end">
              <div
                @click="
                  data.roomStatus == 'Checked In'
                    ? PDFPrintRental(data, true, data.user_sign_contract.id)
                    : ''
                "
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_1318_22597"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="5"
                    y="5"
                    width="22"
                    height="22"
                  >
                    <rect x="5" y="5" width="22" height="22" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1318_22597)">
                    <path
                      d="M19.6652 12.6152V9.86521H12.3319V12.6152H10.9569V9.31507C10.9569 9.08131 11.0363 8.88539 11.1951 8.72733C11.3539 8.56927 11.5507 8.49023 11.7854 8.49023H20.208C20.4466 8.49023 20.645 8.5693 20.8031 8.72742C20.9611 8.88555 21.0402 9.08148 21.0402 9.31523V12.6152H19.6652ZM21.3222 16.2818C21.582 16.2818 21.7997 16.194 21.9754 16.0183C22.1511 15.8426 22.2389 15.6249 22.2389 15.3652C22.2389 15.1054 22.1511 14.8877 21.9754 14.712C21.7997 14.5363 21.582 14.4485 21.3222 14.4485C21.0625 14.4485 20.8448 14.5363 20.6691 14.712C20.4934 14.8877 20.4056 15.1054 20.4056 15.3652C20.4056 15.6249 20.4934 15.8426 20.6691 16.0183C20.8448 16.194 21.0625 16.2818 21.3222 16.2818ZM12.614 22.4165H19.3831C19.4654 22.4165 19.533 22.39 19.5859 22.3371C19.6388 22.2842 19.6652 22.2167 19.6652 22.1344V18.503H12.3319V22.1344C12.3319 22.2167 12.3583 22.2842 12.4112 22.3371C12.4641 22.39 12.5317 22.4165 12.614 22.4165ZM12.614 23.7914C12.1583 23.7914 11.7682 23.6292 11.4437 23.3047C11.1192 22.9802 10.9569 22.5901 10.9569 22.1344V20.1248H8.38319C8.14845 20.1248 7.95168 20.0454 7.79288 19.8866C7.63409 19.7278 7.55469 19.531 7.55469 19.2962V14.9068C7.55469 14.2575 7.77651 13.7133 8.22014 13.274C8.66378 12.8348 9.20583 12.6152 9.84631 12.6152H22.1508C22.8001 12.6152 23.3443 12.8348 23.7836 13.274C24.2228 13.7133 24.4424 14.2575 24.4424 14.9068V19.2962C24.4424 19.531 24.363 19.7278 24.2042 19.8866C24.0454 20.0454 23.8486 20.1248 23.6139 20.1248H21.0402V22.1344C21.0402 22.5901 20.8779 22.9802 20.5534 23.3047C20.2289 23.6292 19.8388 23.7914 19.3831 23.7914H12.614ZM23.0674 18.7498V14.9068C23.0674 14.6471 22.9796 14.4294 22.8039 14.2537C22.6282 14.078 22.4105 13.9902 22.1508 13.9902H9.84631C9.58659 13.9902 9.36888 14.078 9.19318 14.2537C9.01749 14.4294 8.92964 14.6471 8.92964 14.9068V18.7498H10.9569V17.128H21.0402V18.7498H23.0674Z"
                      :fill="
                        data.user_sign_contract?.contractStatus == 'reserved'
                          ? '#B9CCDC'
                          : data.user_sign_contract
                          ? '#003765'
                          : '#B9CCDC'
                      "
                    />
                  </g>
                </svg>
              </div>
              <!-- <div class="" @click=" data.roomStatus == 'Checked In' ? PDFPrintRental(data, false,data.user_sign_contract.id) : ''">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <mask id="mask0_1318_22595" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="5"
                                        y="5" width="22" height="22">
                                        <rect x="5" y="5" width="22" height="22" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_1318_22595)">
                                        <path
                                            d="M13.9009 14.5724H14.9233C15.1531 14.5724 15.3457 14.4947 15.5011 14.3393C15.6565 14.1839 15.7342 13.9913 15.7342 13.7615V12.7391C15.7342 12.5093 15.6565 12.3167 15.5011 12.1613C15.3457 12.0059 15.1531 11.9282 14.9233 11.9282H13.4954C13.3873 11.9282 13.2927 11.9687 13.2116 12.0498C13.1305 12.1309 13.09 12.2255 13.09 12.3336V16.0003C13.09 16.1084 13.1305 16.203 13.2116 16.2841C13.2927 16.3652 13.3873 16.4057 13.4954 16.4057C13.6035 16.4057 13.6981 16.3652 13.7792 16.2841C13.8603 16.203 13.9009 16.1084 13.9009 16.0003V14.5724ZM13.9009 13.7615V12.7391H14.9233V13.7615H13.9009ZM18.4666 16.4057C18.6963 16.4057 18.8889 16.328 19.0443 16.1726C19.1998 16.0172 19.2775 15.8246 19.2775 15.5949V12.7391C19.2775 12.5093 19.1998 12.3167 19.0443 12.1613C18.8889 12.0059 18.6963 11.9282 18.4666 11.9282H17.0739C16.9658 11.9282 16.8712 11.9687 16.7901 12.0498C16.7091 12.1309 16.6685 12.2255 16.6685 12.3336V16.0003C16.6685 16.1084 16.7091 16.203 16.7901 16.2841C16.8712 16.3652 16.9658 16.4057 17.0739 16.4057H18.4666ZM17.4794 15.5949V12.7391H18.4666V15.5949H17.4794ZM21.1108 14.5724H21.7983C21.9064 14.5724 22.001 14.5319 22.0821 14.4508C22.1632 14.3697 22.2038 14.2751 22.2038 14.167C22.2038 14.0588 22.1632 13.9642 22.0821 13.8831C22.001 13.8021 21.9064 13.7615 21.7983 13.7615H21.1108V12.7391H21.7983C21.9064 12.7391 22.001 12.6985 22.0821 12.6175C22.1632 12.5364 22.2038 12.4418 22.2038 12.3336C22.2038 12.2255 22.1632 12.1309 22.0821 12.0498C22.001 11.9687 21.9064 11.9282 21.7983 11.9282H20.7054C20.5972 11.9282 20.5026 11.9687 20.4215 12.0498C20.3405 12.1309 20.2999 12.2255 20.2999 12.3336V16.0003C20.2999 16.1084 20.3405 16.203 20.4215 16.2841C20.5026 16.3652 20.5972 16.4057 20.7054 16.4057C20.8135 16.4057 20.9081 16.3652 20.9892 16.2841C21.0703 16.203 21.1108 16.1084 21.1108 16.0003V14.5724ZM12.3849 21.0419C11.9218 21.0419 11.5299 20.8815 11.2091 20.5607C10.8883 20.2399 10.7278 19.8479 10.7278 19.3849V8.94905C10.7278 8.48601 10.8883 8.09408 11.2091 7.77324C11.5299 7.45241 11.9218 7.29199 12.3849 7.29199H22.8207C23.2838 7.29199 23.6757 7.45241 23.9965 7.77324C24.3174 8.09408 24.4778 8.48601 24.4778 8.94905V19.3849C24.4778 19.8479 24.3174 20.2399 23.9965 20.5607C23.6757 20.8815 23.2838 21.0419 22.8207 21.0419H12.3849ZM12.3849 19.667H22.8207C22.8912 19.667 22.9559 19.6376 23.0147 19.5788C23.0734 19.5201 23.1028 19.4554 23.1028 19.3849V8.94905C23.1028 8.87853 23.0734 8.81388 23.0147 8.75511C22.9559 8.69635 22.8912 8.66697 22.8207 8.66697H12.3849C12.3144 8.66697 12.2497 8.69635 12.191 8.75511C12.1322 8.81388 12.1028 8.87853 12.1028 8.94905V19.3849C12.1028 19.4554 12.1322 19.5201 12.191 19.5788C12.2497 19.6376 12.3144 19.667 12.3849 19.667ZM9.17657 24.2502C8.71354 24.2502 8.32161 24.0898 8.00078 23.769C7.67995 23.4482 7.51953 23.0562 7.51953 22.5932V11.4699C7.51953 11.2751 7.58545 11.1118 7.71728 10.98C7.84911 10.8483 8.01246 10.7824 8.20733 10.7824C8.4022 10.7824 8.56545 10.8483 8.69708 10.98C8.8287 11.1118 8.89451 11.2751 8.89451 11.4699V22.5932C8.89451 22.6637 8.92389 22.7284 8.98265 22.7871C9.04142 22.8459 9.10606 22.8753 9.17657 22.8753H20.2999C20.4947 22.8753 20.658 22.9412 20.7897 23.073C20.9215 23.2048 20.9874 23.3682 20.9874 23.5631C20.9874 23.7579 20.9215 23.9212 20.7897 24.0528C20.658 24.1844 20.4947 24.2502 20.2999 24.2502H9.17657Z"
                                            :fill="data.user_sign_contract?.contractStatus == 'reserved' ? '#B9CCDC' : data.user_sign_contract ? '#003765' : '#B9CCDC'" />
                                    </g>
                                </svg>

                            </div> -->
            </div>
          </div>
        </div>

        <!-- //////////////////////////// Loop Room Contract /////////////////////// -->
      </div>
    </div>
    <b-modal
      centered
      v-model="create"
      size="xl"
      hide-backdrop
      hide-header-close
      hide-header
      hide-footer
      class="p-[-20px] text-custom"
    >
      <div>
        <div class="flex justify-between pl-[20px] pr-[20px]">
          <div
            class="text-custom flex justify-center items-center text-[18px] font-bold"
          >
            {{ isEditContract ? "แก้ไขสัญญาเช่าห้อง" : "เพิ่มสัญญาเช่าห้อง" }}
            {{ create_room_number }}
          </div>
          <div @click="create = false" class="cursor-pointer">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_417_4814"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_417_4814)">
                <path
                  d="M12.0005 13.0538L6.92737 18.1269C6.78892 18.2654 6.61489 18.3362 6.40527 18.3394C6.19567 18.3426 6.01844 18.2718 5.87357 18.1269C5.72869 17.982 5.65625 17.8064 5.65625 17.6C5.65625 17.3936 5.72869 17.218 5.87357 17.0731L10.9466 12L5.87357 6.92689C5.73511 6.78844 5.66427 6.6144 5.66107 6.40479C5.65786 6.19519 5.72869 6.01795 5.87357 5.87309C6.01844 5.7282 6.19407 5.65576 6.40047 5.65576C6.60687 5.65576 6.78251 5.7282 6.92737 5.87309L12.0005 10.9462L17.0736 5.87309C17.212 5.73462 17.3861 5.66379 17.5957 5.66059C17.8053 5.65737 17.9825 5.7282 18.1274 5.87309C18.2723 6.01795 18.3447 6.19359 18.3447 6.39999C18.3447 6.60639 18.2723 6.78202 18.1274 6.92689L13.0543 12L18.1274 17.0731C18.2658 17.2115 18.3367 17.3856 18.3399 17.5952C18.3431 17.8048 18.2723 17.982 18.1274 18.1269C17.9825 18.2718 17.8069 18.3442 17.6005 18.3442C17.3941 18.3442 17.2184 18.2718 17.0736 18.1269L12.0005 13.0538Z"
                  fill="#5C6B79"
                />
              </g>
            </svg>
          </div>
        </div>
        <!-- <div class="w-[100%] h-[1px]  mt-[24px] mb-[14px] bg-gray-200 border-0 dark:bg-gray-700"></div> -->
        <div class="pl-[20px] pr-[20px] mt-[24px]">
          <div
            v-if="check_rent == 'reserved'"
            class="mb-[8px] rounded-[10px] bg-[#EAF3FB] text-[#003765] text-[13px] px-[14px] py-[10px]"
          >
            ห้องนี้มีการจองอยู่ — ข้อมูลผู้เช่าและเงินที่ชำระตอนจองถูกกรอกให้แล้ว
            กรอกข้อมูลที่เหลือแล้วกด "บันทึก" เพื่อทำสัญญาเช่า (สถานะห้องจะเปลี่ยนเป็น "เข้าพักแล้ว")
          </div>
          <div
            v-if="isEditContract"
            class="mb-[8px] rounded-[10px] bg-[#EAF3FB] text-[#003765] text-[13px] px-[14px] py-[10px]"
          >
            กำลังแก้ไขสัญญาเช่าที่มีอยู่ — การบันทึกจะอัปเดตสัญญาฉบับเดิม
            (ไม่สร้างสัญญาใหม่ ไม่แตะเลขมิเตอร์เริ่มต้นและรายรับที่บันทึกไว้แล้ว)
          </div>
          <div class="mt-[24px]">
            <div class="w-[100%] flex">
              <div class="w-[30%] text-custom flex items-start font-bold text-[#003765]">ผู้เช่า</div>
              <div class="w-[70%]">
                <div class="grid grid-cols-2 text-custom" v-if="!isEditContract">
                  <div class="flex">
                    <vs-radio
                      v-model="room_detail_create.check_user"
                      color="#003765"
                      :val="true"
                    >
                      ผู้เช่าในระบบ
                    </vs-radio>
                    <vs-radio
                      v-model="room_detail_create.check_user"
                      color="#003765"
                      :val="false"
                      v-if="check_rent != 'reserved'"
                    >
                      ผู้เช่าใหม่
                    </vs-radio>
                  </div>
                </div>
                <div
                  class="grid grid-cols-2 text-custom mt-[14px]"
                  v-if="room_detail_create.check_user == true && !isEditContract"
                >
                  <div>
                    <div class="">
                      <span class="text-[red] mr-[2px]">*</span
                      >ค้นหาผู้เช่าด้วยอีเมล
                    </div>
                    <div class="flex items-center gap-[8px]">
                      <input
                        type="input"
                        class="h-[36px] flex-1 rounded-[12px] bg-[#F3F7FA]"
                        v-model="searchEmail"
                        @keyup.enter="getUserDetail(searchEmail)"
                      />
                      <vs-button primary @click="getUserDetail(searchEmail)"
                        >ค้นหา</vs-button
                      >
                    </div>
                    <div
                      v-if="room_detail_create.id"
                      class="text-[11px] text-[#8A97A2] mt-[4px]"
                    >
                      แก้ไขข้อมูลด้านล่างจะอัปเดตโปรไฟล์ผู้เช่าในระบบด้วย
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-8 text-custom mt-[14px]">
                  <!-- <div>
                                        <div><span class="text-[red] mr-[2px]">*</span>คำนำหน้า</div>
                                        <select :disabled="room_detail_create.check_user == true" placeholder="ชื่อ" id="mr"
                                            class="mt-[6px] pl-[4px] pr-[4px] h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA]"
                                            v-model="room_detail_create.sex">
                                            <option label="นาย" :value="true">
                                                นาย
                                            </option>
                                            <option label="นางสาว" :value="false">
                                                นางสาว
                                            </option>
                                        </select>
                                    </div> -->
                  <div class="col-span-3 ml-[8px]">
                    <div><span class="text-[red] mr-[2px]">*</span>ชื่อ</div>
                    <input
                      type="input"
                      class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA]"
                      v-model="room_detail_create.name"
                      required
                    />
                    <div v-if="fieldErrors.name" class="text-[red] text-[12px] mt-[2px]">
                      {{ fieldErrors.name }}
                    </div>
                  </div>
                  <div class="col-span-3 ml-[8px]">
                    <div><span class="text-[red] mr-[2px]">*</span>สกุล</div>
                    <input
                      type="input"
                      class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA]"
                      v-model="room_detail_create.last_name"
                      required
                    />
                    <div v-if="fieldErrors.last_name" class="text-[red] text-[12px] mt-[2px]">
                      {{ fieldErrors.last_name }}
                    </div>
                  </div>
                  <div class="ml-[8px]">
                    <div>ชื่อเล่น</div>
                    <input
                      type="input"
                      class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA]"
                      v-model="room_detail_create.nick_name"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-8 text-custom w-[70%]">
                <div class="col-span-4">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>เบอร์โทรศัพท์
                  </div>
                  <input
                    type="tel"
                    maxlength="10"
                    class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA]"
                    v-model="room_detail_create.phone"
                    @input="onPhoneInput"
                    required
                  />
                  <div v-if="fieldErrors.phone" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.phone }}
                  </div>
                </div>
                <div class="col-span-4 ml-[8px]">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>หมายเลขบัตรประชาชน / พาสปอร์ต
                    <span class="text-[#5C6B79]"></span>
                  </div>
                  <input
                    type="input"
                    maxlength="20"
                    class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA]"
                    v-model="room_detail_create.id_card"
                    @input="onIdCardInput"
                    required
                  />
                  <div v-if="fieldErrors.id_card" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.id_card }}
                  </div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-6 text-custom w-[70%]">
                <div class="col-span-3">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>Email
                    <span class="text-[#5C6B79]"
                      >สำหรับล็อกอินเข้าใช้แอปพลิเคชัน</span
                    >
                  </div>
                  <input
                    type="email"
                    class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA] mt-[6px] pl-[12px] pr-[12px]"
                    v-model="room_detail_create.email"
                    required
                  />
                  <div v-if="fieldErrors.email" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.email }}
                  </div>
                </div>
                <div class="col-span-3 ml-[8px]">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>วัน/เดือน/ปีเกิด
                    (ค.ศ.)
                  </div>
                  <DateField
                    class="w-[100%] mt-[6px]"
                    v-model="room_detail_create.birth"
                    :required="true"
                  />
                  <div v-if="fieldErrors.birth" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.birth }}
                  </div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-6 text-custom w-[70%]">
                <div class="col-span-6">
                  <div><span class="text-[red] mr-[2px]">*</span>ที่อยู่</div>
                  <input
                    type="input"
                    class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA] mt-[6px] pl-[12px] pr-[12px]"
                    v-model="room_detail_create.address"
                    required
                  />
                  <div v-if="fieldErrors.address" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.address }}
                  </div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[24px]">
              <div class="w-[30%] text-custom flex items-start font-bold text-[#003765]">
                สัญญา
              </div>
              <div class="grid grid-cols-8 text-custom w-[70%]">
                <div class="col-span-4">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>วันที่ทำสัญญา
                  </div>
                  <DateField
                    class="w-[100%] mt-[6px]"
                    v-model="room_detail_create.date_sign"
                    :required="true"
                  />
                  <div v-if="fieldErrors.date_sign" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.date_sign }}
                  </div>
                </div>
                <div class="col-span-4 ml-[8px]">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>ระยะเวลาสัญญา (เดือน)
                  </div>
                  <div class="flex gap-[6px] mt-[6px]">
                    <button
                      v-for="p in [3, 6, 12]"
                      :key="p"
                      type="button"
                      @click="room_detail_create.contract_duration = String(p)"
                      class="h-[36px] px-[12px] rounded-[12px] text-[13px] border transition-colors"
                      :class="String(room_detail_create.contract_duration) === String(p)
                        ? 'bg-[#003765] text-white border-[#003765]'
                        : 'bg-[#F3F7FA] text-[#5C6B79] border-[#E3EAF1] hover:border-[#B9CCDC]'"
                    >
                      {{ p }} เดือน
                    </button>
                    <select
                      v-model="room_detail_create.contract_duration"
                      class="h-[36px] flex-1 rounded-[12px] pl-[8px] pr-[8px] bg-[#F3F7FA] border border-[#E3EAF1]"
                    >
                      <option value="">อื่น ๆ</option>
                      <option v-for="n in 24" :key="n" :value="String(n)">{{ n }} เดือน</option>
                    </select>
                  </div>
                  <div v-if="fieldErrors.contract_duration" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.contract_duration }}
                  </div>
                </div>
                <div class="col-span-4 mt-[16px]">
                  <div class="flex items-center justify-between">
                    <span>
                      <span class="text-[red] mr-[2px]">*</span>วันสิ้นสุดสัญญา
                    </span>
                    <span
                      v-if="!expDateTouched && room_detail_create.date_sign && room_detail_create.contract_duration"
                      class="text-[11px] text-[#8A97A2]"
                    >
                      คำนวณอัตโนมัติ
                    </span>
                    <button
                      v-else-if="expDateTouched"
                      type="button"
                      class="text-[11px] text-[#3A89CB]"
                      @click="expDateTouched = false; recomputeExpDate()"
                    >
                      คำนวณใหม่
                    </button>
                  </div>
                  <DateField
                    class="w-[100%] mt-[6px]"
                    v-model="room_detail_create.exp_date"
                    :required="true"
                    @input="expDateTouched = true"
                  />
                  <div v-if="fieldErrors.exp_date" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.exp_date }}
                  </div>
                </div>
                <div class="col-span-4 ml-[8px] mt-[16px]">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>ประเภทห้องพัก
                  </div>
                  <select
                    placeholder="Select"
                    v-model="room_detail_create.type_room"
                    disabled
                    class="h-[36px] w-[100%] mt-[6px] rounded-[12px] pl-[8px] pr-[8px] bg-[#F3F7FA]"
                  >
                    <option
                      v-for="type_room in room_type"
                      :value="type_room.id"
                    >
                      {{ type_room.attributes.roomTypeName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[24px]" v-if="!isEditContract">
              <div class="w-[30%] text-custom flex items-start font-bold text-[#003765]">
                มิเตอร์เริ่มต้น
              </div>
              <div class="grid grid-cols-8 text-custom w-[70%]">
                <div class="col-span-4">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>เลขมิเตอร์ค่าน้ำเดือนล่าสุด
                  </div>
                  <input
                    type="number"
                    class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA] mt-[6px]"
                    v-model="room_detail_create.water"
                    required
                  />
                  <div v-if="fieldErrors.water" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.water }}
                  </div>
                </div>
                <div class="col-span-4 ml-[8px]">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>เลขมิเตอร์ค่าไฟเดือนล่าสุด
                  </div>
                  <input
                    type="number"
                    class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA] mt-[6px]"
                    v-model="room_detail_create.ele"
                    required
                  />
                  <div v-if="fieldErrors.ele" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.ele }}
                  </div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[24px]">
              <div class="w-[30%] text-custom flex items-start font-bold text-[#003765]">
                เงินมัดจำ
              </div>
              <div class="grid grid-cols-8 text-custom w-[70%]">
                <div class="col-span-4">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>ค่าประกันห้อง
                  </div>
                  <input
                    type="number"
                    class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA] mt-[6px]"
                    v-model="room_detail_create.roomInsuranceDeposit"
                    required
                  />
                  <div v-if="fieldErrors.roomInsuranceDeposit" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.roomInsuranceDeposit }}
                  </div>
                </div>
                <div class="col-span-4 ml-[8px]">
                  <div>
                    <span class="text-[red] mr-[2px]">*</span>วางเงินค่าเช่าล่วงหน้า (บาท)
                  </div>
                  <input
                    type="number"
                    class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA] mt-[6px]"
                    v-model="room_detail_create.room_deposit"
                    required
                  />
                  <div v-if="fieldErrors.room_deposit" class="text-[red] text-[12px] mt-[2px]">
                    {{ fieldErrors.room_deposit }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-end mt-[30px]">
          <div>
            <vs-button dark shadow @click="create = false">
              <div class="text-custom">ยกเลิก</div>
            </vs-button>
          </div>
          <div>
            <vs-button @click="validateField(data_mock, true)" color="#003765">
              <div class="text-custom">บันทึก</div>
            </vs-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      centered
      v-model="detail"
      size="xl"
      hide-backdrop
      hide-header-close
      hide-header
      hide-footer
      class="p-[-20px] text-custom"
    >
      <div>
        <div class="flex justify-between pl-[20px] pr-[20px]">
          <div
            class="text-custom flex justify-center items-center text-[18px] font-bold"
          >
            รายละเอียดสัญญาเช่า ห้อง {{ room_detail.number_room }}
          </div>
          <div @click="detail = false" class="cursor-pointer">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_417_4814"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_417_4814)">
                <path
                  d="M12.0005 13.0538L6.92737 18.1269C6.78892 18.2654 6.61489 18.3362 6.40527 18.3394C6.19567 18.3426 6.01844 18.2718 5.87357 18.1269C5.72869 17.982 5.65625 17.8064 5.65625 17.6C5.65625 17.3936 5.72869 17.218 5.87357 17.0731L10.9466 12L5.87357 6.92689C5.73511 6.78844 5.66427 6.6144 5.66107 6.40479C5.65786 6.19519 5.72869 6.01795 5.87357 5.87309C6.01844 5.7282 6.19407 5.65576 6.40047 5.65576C6.60687 5.65576 6.78251 5.7282 6.92737 5.87309L12.0005 10.9462L17.0736 5.87309C17.212 5.73462 17.3861 5.66379 17.5957 5.66059C17.8053 5.65737 17.9825 5.7282 18.1274 5.87309C18.2723 6.01795 18.3447 6.19359 18.3447 6.39999C18.3447 6.60639 18.2723 6.78202 18.1274 6.92689L13.0543 12L18.1274 17.0731C18.2658 17.2115 18.3367 17.3856 18.3399 17.5952C18.3431 17.8048 18.2723 17.982 18.1274 18.1269C17.9825 18.2718 17.8069 18.3442 17.6005 18.3442C17.3941 18.3442 17.2184 18.2718 17.0736 18.1269L12.0005 13.0538Z"
                  fill="#5C6B79"
                />
              </g>
            </svg>
          </div>
        </div>
        <!-- <div class="w-[100%] h-[1px]  mt-[24px] mb-[14px] bg-gray-200 border-0 dark:bg-gray-700"></div> -->
        <div class="pl-[20px] pr-[20px] mt-[24px]">
          <div class="font-bold text-custom">รายละเอียดสัญญาเช่า</div>
          <div class="mt-[24px]">
            <div class="w-[100%] flex">
              <div class="w-[30%] text-custom flex items-start text-[#5C6B79]">
                ข้อมูลหลัก
              </div>
              <dvi class="w-[70%]">
                <div class="grid grid-cols-8 text-custom">
                  <div>
                    <div class="text-[#003765]">คำนำหน้า</div>
                    <div class="mt-[12px]">
                      {{
                        room_detail.sex === true
                          ? "นาย"
                          : room_detail.sex === null
                          ? "-"
                          : "นาง/นางสาว"
                      }}
                    </div>
                  </div>
                  <div class="col-span-3 ml-[8px]">
                    <div class="text-[#003765]">ชื่อ</div>
                    <div class="mt-[12px]">{{ room_detail.name }}</div>
                  </div>
                  <div class="col-span-3 ml-[8px]">
                    <div class="text-[#003765]">สกุล</div>
                    <div class="mt-[12px]">{{ room_detail.last_name }}</div>
                  </div>
                  <div class="ml-[8px]">
                    <div class="text-[#003765]">ชื่อเล่น</div>
                    <div class="mt-[12px]">
                      {{ room_detail.nick_name ? room_detail.nick_name : "-" }}
                    </div>
                  </div>
                </div>
              </dvi>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-8 text-custom w-[70%]">
                <div class="col-span-4 mt-[14px]">
                  <div class="text-[#003765]">เบอร์โทรศัพท์</div>
                  <div class="mt-[12px]">
                    {{ room_detail.phone ? room_detail.phone : "-" }}
                  </div>
                </div>
                <div class="col-span-4 ml-[8px] mt-[14px]">
                  <div class="text-[#003765]">หมายเลขบัตรประชาชน / พาสปอร์ต</div>
                  <div class="mt-[12px]">
                    {{ room_detail.id_card ? room_detail.id_card : "-" }}
                  </div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-6 text-custom w-[70%]">
                <div class="col-span-2 mt-[14px]">
                  <div class="text-[#003765]">วัน/เดือน/ปีเกิด (ค.ศ.)</div>
                  <div class="mt-[12px]">{{ fmtDate(room_detail.birth) }}</div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-6 text-custom w-[70%]">
                <div class="col-span-2 mt-[14px]">
                  <div class="text-[#003765]">ที่อยู่</div>
                  <div class="mt-[12px]">
                    {{ room_detail.address ? room_detail.address : "-" }}
                  </div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-8 text-custom w-[70%]">
                <div class="col-span-4 mt-[14px]">
                  <div class="text-[#003765]">วันที่ทำสัญญา</div>
                  <div class="mt-[12px]">{{ fmtDate(room_detail.date_sign) }}</div>
                </div>
                <div class="col-span-4 ml-[8px] mt-[14px]">
                  <div class="text-[#003765]">ระยะเวลาสัญญา</div>
                  <div class="mt-[12px]" v-if="room_detail.contract_duration">
                    {{ room_detail.contract_duration }} เดือน
                  </div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-8 text-custom w-[70%]">
                <div class="col-span-4 mt-[14px]">
                  <div class="text-[#003765]">ประเภทห้องเช่า</div>
                  <div class="mt-[12px]">{{ room_detail.type_room }}</div>
                </div>
                <div class="col-span-4 ml-[8px] mt-[14px]">
                  <div class="text-[#003765]">ค่าประกันห้อง</div>
                  <div class="mt-[12px]">{{ money(room_detail.roomInsurance_deposit) }}</div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-8 text-custom w-[70%]">
                <div class="col-span-4 mt-[14px]">
                  <div class="text-[#003765]">วันสิ้นสุดสัญญา</div>
                  <div class="mt-[12px] flex items-center gap-[8px]">
                    {{ fmtDate(room_detail.exp_date) }}
                    <span
                      v-if="expDaysLeftLabel(room_detail.exp_date)"
                      class="text-[11px] px-[8px] py-[2px] rounded-full"
                      :class="expDaysLeftClass(room_detail.exp_date)"
                    >
                      {{ expDaysLeftLabel(room_detail.exp_date) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-[100%] flex mt-[14px]">
              <div class="w-[30%] text-custom flex items-start"></div>
              <div class="grid grid-cols-8 text-custom w-[70%]">
                <div class="col-span-4 mt-[14px]">
                  <div class="text-[#003765]">วางเงินค่าเช่าล่วงหน้า</div>
                  <div class="mt-[12px]">{{ money(room_detail.room_deposit) }}</div>
                </div>
              </div>
            </div>
            <div class="flex justify-end mt-[30px]">
              <div>
                <vs-button dark shadow @click="detail = false">
                  <div class="text-custom">ปิด</div>
                </vs-button>
              </div>
              <div>
                <vs-button @click="editContract()" color="#003765">
                  <div class="text-custom">แก้ไขสัญญาเช่า</div>
                </vs-button>
              </div>
            </div>
            <!-- <div class="w-[100%] flex mt-[14px]">
                            <div class="w-[30%] text-custom flex items-start">รายละเอียดการจอง</div>
                            <div class="grid grid-cols-8  text-custom w-[70%] ">
                                <div class="col-span-4">
                                    <div>วันที่เข้าพัก</div>
                                    <input type="input" class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA]" />
                                </div>
                                <div class="col-span-4  ml-[8px]">
                                    <div>เลือกห้อง</div>
                                    <input type="input" class="h-[36px] w-[100%] rounded-[12px] bg-[#F3F7FA]" />
                                </div>
                            </div>
                        </div> -->
          </div>
        </div>
      </div>
    </b-modal>
    <PDFgeneratorRentalContract ref="childComponentPDFRental" />
  </div>
</template>
<script>
import axios from "axios";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import download from "downloadjs";
import fontkit from "@pdf-lib/fontkit";
import { convertDateNoTime, recordDepositIncome } from "@/components/hook/hook";
import PDFgeneratorRentalContract from "@/views/rental-contract/component/PDFgeneratorRentalContract";
export default {
  components: { PDFgeneratorRentalContract },
  data() {
    return {
      check_rent: "",
      create_room_number: "",
      detail: false,
      create: false,
      popup_filter: false,
      contract: [],
      data_mock: {},
      users: [],
      id_user: "",
      tab_floor: "0",
      name_floor: "",
      filter: {
        select: [],
        checkSelect: [],
        search: "",
        floor: "",
        Id_card: "",
      },
      searchEmail: "",
      room_detail: {
        sex: null,
        name: "",
        last_name: "",
        nick_name: "",
        phone: "",
        id_card: "",
        birth: "",
        address: "",
        date_sign: "",
        exp_date: "",
        roomInsurance_deposit: "",
        contract_duration: "",
        room_deposit: "",
        type_room: "",
      },
      room_detail_create: {
        check_user: true,
        water: 0,
        ele: 0,
        id: "",
        id_room: "",
        sex: null,
        name: "",
        last_name: "",
        nick_name: "",
        email: "",
        phone: "",
        id_card: "",
        birth: "",
        address: "",
        date_sign: "",
        exp_date: "",
        roomInsuranceDeposit: "",
        contract_duration: "",
        room_deposit: "",
        type_room: "",
        existing_contract_id: "",
      },
      // exp_date auto-fills from date_sign + contract_duration until the admin
      // edits it by hand (then this flag stops the overwrite).
      expDateTouched: false,
      // earnest already recorded as income at booking time - so converting a
      // booking to a contract only books the additional advance-rent, if any.
      bookedEarnest: 0,
      // true when the create form is reused to EDIT an already-signed contract
      // (opened from the detail modal): PUT in place, no meter/deposit-income
      // side effects, no room-status change beyond what already holds.
      isEditContract: false,
      // per-field validation errors, keyed by room_detail_create field name
      fieldErrors: {},
      room_type: [],
      floorRoom: [],
      originalUserData: null,
      errorFieldMessage: "",
      id_sign: "",
    };
  },
  watch: {
    "room_detail_create.date_sign"() {
      this.recomputeExpDate();
    },
    "room_detail_create.contract_duration"() {
      this.recomputeExpDate();
    },
  },
  mounted() {
    this.filter.checkSelect = [
      "Checked In",
      "Available",
      "Reserved",
      "Maintenance",
    ];
    console.log("State.Building", this.$store.state.building);
    this.getFloorRoom();
    // this.getUser()
  },
  created() {
    // const loading = this.$vs.loading({
    //     opacity: 1,
    // })
    // setTimeout(() => {
    //     loading.close()
    // }, 1000)
  },
  methods: {
    convertDateNoTime,
    fmtDate(d) {
      return d ? convertDateNoTime(d) : "-";
    },
    money(v) {
      if (v === null || v === undefined || v === "") return "-";
      return `${this.$formatNumber(Number(v))} บาท`;
    },
    // days between today and a YYYY-MM-DD contract end date
    expDaysLeft(dateStr) {
      if (!dateStr) return null;
      const end = new Date(dateStr + "T00:00:00");
      if (isNaN(end.getTime())) return null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return Math.round((end.getTime() - today.getTime()) / 86400000);
    },
    expDaysLeftLabel(dateStr) {
      const d = this.expDaysLeft(dateStr);
      if (d === null) return "";
      if (d < 0) return `หมดอายุแล้ว ${Math.abs(d)} วัน`;
      if (d === 0) return "หมดอายุวันนี้";
      return `เหลืออีก ${d} วัน`;
    },
    expDaysLeftClass(dateStr) {
      const d = this.expDaysLeft(dateStr);
      if (d === null) return "";
      if (d <= 7) return "bg-[#FFE1E8] text-[#D44769]";
      if (d <= 30) return "bg-[#FFF2BC] text-[#C77700]";
      return "bg-[#CFFBDA] text-[#0B9A3C]";
    },
    // Fill the tenant fields of the create form from a users-permissions user
    // object (flat shape - id/firstName/lastName/...). Used for booked rooms
    // (data already populated), the email search, and the idCard lookup.
    applyUserToForm(u) {
      if (!u) return;
      this.room_detail_create.id = u.id || "";
      this.room_detail_create.name = u.firstName || "";
      this.room_detail_create.last_name = u.lastName || "";
      this.room_detail_create.nick_name = u.nickName || "";
      this.room_detail_create.phone = u.phone || "";
      this.room_detail_create.email = u.email || "";
      this.room_detail_create.id_card = u.idCard || "";
      this.room_detail_create.address = u.contactAddress || "";
      this.room_detail_create.birth = u.dateOfBirth || "";
      this.searchEmail = u.email || "";
      this.setOriginalUserData(u);
    },
    clearFormUser() {
      this.room_detail_create.id = "";
      this.room_detail_create.name = "";
      this.room_detail_create.last_name = "";
      this.room_detail_create.nick_name = "";
      this.room_detail_create.phone = "";
      this.room_detail_create.email = "";
      this.room_detail_create.id_card = "";
      this.room_detail_create.address = "";
      this.room_detail_create.birth = "";
      this.originalUserData = null;
    },
    // exp_date = date_sign + N months - 1 day (Thai lease convention), unless
    // the admin has edited the end date by hand (expDateTouched).
    recomputeExpDate() {
      if (this.expDateTouched) return;
      const start = this.room_detail_create.date_sign;
      const months = parseInt(this.room_detail_create.contract_duration, 10);
      if (!start || !months) return;
      const d = new Date(start + "T00:00:00");
      if (isNaN(d.getTime())) return;
      const startDay = d.getDate();
      d.setMonth(d.getMonth() + months);
      // month overflow (e.g. 31 Jan + 1 -> 3 Mar): pull back to last day of the
      // target month
      if (d.getDate() !== startDay) d.setDate(0);
      d.setDate(d.getDate() - 1);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      this.room_detail_create.exp_date = `${y}-${m}-${dd}`;
    },
    getFloorStorageKey() {
      return `rentalContractSelectedFloor_${this.$store.state.building}`;
    },
    toArabicDigits(value) {
      const thaiDigits = "๐๑๒๓๔๕๖๗๘๙";
      return String(value || "").replace(/[๐-๙]/g, (digit) =>
        thaiDigits.indexOf(digit)
      );
    },
    extractFloorNumber(floorName) {
      const normalized = this.toArabicDigits(floorName);
      const match = normalized.match(/-?\d+(\.\d+)?/);
      return match ? Number(match[0]) : Number.POSITIVE_INFINITY;
    },
    sortFloorsByName(floors) {
      return [...(floors || [])].sort((a, b) => {
        const aName = a?.attributes?.floorName || "";
        const bName = b?.attributes?.floorName || "";
        const numDiff =
          this.extractFloorNumber(aName) - this.extractFloorNumber(bName);
        if (numDiff !== 0) {
          return numDiff;
        }
        return aName.localeCompare(bName, "th", {
          numeric: true,
          sensitivity: "base",
        });
      });
    },
    selectFloor(floorData, index) {
      this.tab_floor = index;
      this.filter.floor = floorData.id;
      this.name_floor = floorData.attributes.floorName;
      localStorage.setItem(this.getFloorStorageKey(), String(floorData.id));
      this.getRentalContract();
    },
    async PDFPrintRental(tr, check, id, data) {
      this.$refs.childComponentPDFRental.generatePDF(tr, check, id, data);
      setTimeout(() => {
        this.$refs.childComponentPDFRental.generatePDF(tr, check, id, data);
      }, 100);
    },
    openNotificationRenralPage(position = null, color, title, desc) {
      const noti = this.$vs.notification({
        sticky: true,
        color,
        position,
        title,
      });
    },
    routeTo(path) {
      this.$router.push({
        path: path,
      });
    },
    buildUserPayloadFromForm() {
      return {
        username: this.room_detail_create.email,
        email: this.room_detail_create.email,
        firstName: this.room_detail_create.name,
        lastName: this.room_detail_create.last_name,
        nickName: this.room_detail_create.nick_name,
        phone: this.room_detail_create.phone,
        idCard: this.room_detail_create.id_card,
        contactAddress: this.room_detail_create.address,
        dateOfBirth: this.room_detail_create.birth,
      };
    },
    setOriginalUserData(user = {}) {
      this.originalUserData = {
        username: user.username || user.email || "",
        email: user.email || "",
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        nickName: user.nickName || "",
        phone: user.phone || "",
        idCard: user.idCard || "",
        contactAddress: user.contactAddress || "",
        dateOfBirth: user.dateOfBirth || "",
      };
    },
    hasUserDataChanged() {
      if (!this.originalUserData) {
        return false;
      }
      const currentPayload = this.buildUserPayloadFromForm();
      return Object.keys(currentPayload).some(
        (key) => (currentPayload[key] || "") !== (this.originalUserData[key] || "")
      );
    },
    syncExistingUserIfNeeded() {
      if (!this.room_detail_create.id || !this.room_detail_create.check_user) {
        return Promise.resolve();
      }
      if (!this.hasUserDataChanged()) {
        return Promise.resolve();
      }
      const payload = this.buildUserPayloadFromForm();
      return axios
        .put(
          "https://api.resguru.app/api/users/" + this.room_detail_create.id,
          payload
        )
        .then(() => {
          this.setOriginalUserData(payload);
        });
    },
    // True only for the form-open case (banner, hides "ผู้เช่าใหม่" radio).
    // Saving this form ALWAYS creates a full "rent" contract - a booking is
    // not a rent, it just pre-fills the data.
    isFromBooking() {
      return !!this.room_detail_create.existing_contract_id;
    },
    buildContractPayload(userId) {
      const payload = {
        room: this.room_detail_create.id_room,
        contractStatus: "rent",
        users_permissions_user: userId,
        checkInDate: this.room_detail_create.date_sign,
        contractEndDate: this.room_detail_create.exp_date,
        roomDeposit: parseInt(this.room_detail_create.room_deposit),
        roomInsuranceDeposit: parseInt(
          this.room_detail_create.roomInsuranceDeposit
        ),
        contractDuration: parseInt(this.room_detail_create.contract_duration),
      };
      // Editing a signed contract must not rewrite the move-in meter baselines.
      if (!this.isEditContract) {
        payload.startElectric = this.room_detail_create.ele;
        payload.startWater = this.room_detail_create.water;
      }
      return payload;
    },
    // Update the existing reserved booking's record in place when one
    // exists, instead of POSTing a second row - room.user_sign_contract is
    // oneToOne, so a second POST for the same room would orphan the
    // original booking record rather than replace it.
    saveContractRecord(payload) {
      if (this.room_detail_create.existing_contract_id) {
        return axios.put(
          "https://api.resguru.app/api/user-sign-contracts/" +
            this.room_detail_create.existing_contract_id,
          { data: payload }
        );
      }

      return axios.post("https://api.resguru.app/api/user-sign-contracts", {
        data: payload,
      });
    },
    updateRoomAfterContract() {
      return axios.put(
        "https://api.resguru.app/api/rooms/" + this.room_detail_create.id_room,
        {
          data: {
            room_type: this.room_detail_create.type_room,
            roomStatus: "Checked In",
          },
        }
      );
    },
    recordMoveInDepositIncome() {
      // roomDeposit (advance rent) is income at move-in; roomInsuranceDeposit
      // is not building revenue. When converting a booking, its earnest was
      // already recorded as income in "จองห้อง" - only book the difference.
      const total = Number(this.room_detail_create.room_deposit) || 0;
      const alreadyBooked = this.isFromBooking()
        ? Number(this.bookedEarnest) || 0
        : 0;
      const amount = total - alreadyBooked;
      if (amount <= 0) {
        return Promise.resolve();
      }
      return recordDepositIncome(
        axios,
        this.$store.state.building,
        amount,
        `ค่าเช่าล่วงหน้า (ทำสัญญาเช่า ห้อง ${this.create_room_number || ''})`.trim()
      );
    },
    // Removed createUtilityRecords()/getPreviousMonthYearFromCheckIn():
    // they used to backdate a "previous month" water-fee/electric-fee
    // record to the move-in reading, tagged to the calendar month before
    // check-in. That collides with a real record for that room+month
    // whenever the room was occupied the prior month (a mid-month tenant
    // handoff) - Strapi has no uniqueness constraint on
    // (room, billMonth, billYear), so it silently created a second,
    // conflicting record instead of erroring. The backend's
    // generateInvoice/reGenerateInvoice now falls back to
    // user_sign_contract.startWater/startElectric directly when no
    // previous-month record exists, so this baseline no longer needs a
    // synthetic record at all - startWater/startElectric (still set in
    // buildContractPayload() above) is sufficient on its own.
    onPhoneInput(e) {
      this.room_detail_create.phone = (e.target.value || "")
        .replace(/\D/g, "")
        .slice(0, 10);
    },
    onIdCardInput(e) {
      this.room_detail_create.id_card = (e.target.value || "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .slice(0, 20);
    },
    validateField(a, b) {
      const f = this.room_detail_create;
      const errors = {};
      const req = (key, msg) => {
        if (f[key] === "" || f[key] === null || f[key] === undefined)
          errors[key] = msg;
      };

      req("name", "กรุณากรอกชื่อ");
      req("last_name", "กรุณากรอกนามสกุล");
      req("address", "กรุณากรอกที่อยู่");
      req("birth", "กรุณาเลือกวันเกิด");
      req("date_sign", "กรุณาเลือกวันที่ทำสัญญา");
      req("room_deposit", "กรุณากรอกเงินค่าเช่าล่วงหน้า");

      if (!f.email) errors.email = "กรุณากรอกอีเมล";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email))
        errors.email = "รูปแบบอีเมลไม่ถูกต้อง";

      if (!f.phone) errors.phone = "กรุณากรอกเบอร์โทรศัพท์";
      else if (!/^0\d{9}$/.test(f.phone))
        errors.phone = "เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 0 และมี 10 หลัก";

      if (!f.id_card) errors.id_card = "กรุณากรอกหมายเลขบัตรประชาชน / พาสปอร์ต";
      else if (!/^\d{13}$/.test(f.id_card) && f.id_card.length < 6)
        errors.id_card = "หมายเลขไม่ถูกต้อง";

      if (!this.isEditContract) {
        req("water", "กรุณากรอกเลขมิเตอร์ค่าน้ำ");
        req("ele", "กรุณากรอกเลขมิเตอร์ค่าไฟ");
      }
      req("exp_date", "กรุณาเลือกวันสิ้นสุดสัญญา");
      req("roomInsuranceDeposit", "กรุณากรอกค่าประกันห้อง");
      req("contract_duration", "กรุณาเลือกระยะเวลาสัญญา");
      req("type_room", "ห้องนี้ยังไม่ได้กำหนดประเภทห้อง");

      if (f.date_sign && f.exp_date && f.exp_date <= f.date_sign)
        errors.exp_date = "วันสิ้นสุดสัญญาต้องอยู่หลังวันที่ทำสัญญา";

      this.fieldErrors = errors;

      if (Object.keys(errors).length > 0) {
        this.$showNotification("danger", "กรุณาตรวจสอบข้อมูลที่ทำเครื่องหมายสีแดง");
        this.errorFieldMessage = "กรุณากรอกข้อมูลให้ครบถ้วน";
        return;
      }

      this.errorFieldMessage = "";
      this.submitSign(a, b);
    },
    getRentalContract(code) {
      this.contract = [];
      const loading = this.$vs.loading();
      const output =
        this.filter.select.length > 0
          ? this.filter.select.join(",")
          : this.filter.checkSelect.join(",");
      fetch(
        "https://api.resguru.app/api/getRoomContract?buildingid=" +
          this.$store.state.building +
          "&buildingFloor=" +
          this.filter.floor +
          "&roomStatus=" +
          output
      )
        .then((response) => response.json())
        .then((resp) => {
          if (code == 8) {
            this.contract = resp.data.filter((item) =>
              item.RoomNumber.toLowerCase().includes(
                this.filter.search.toLowerCase()
              )
            );
          } else {
            this.contract = resp.data;
          }
          console.log("Return from getRentalContract()", resp.data);
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลสัญญาเช่า');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          loading.close();
        });
    },
    getFloorRoom() {
      // const loading = this.$vs.loading()
      fetch(
        "https://api.resguru.app/api" +
          "/building-floors?filters[building][id][$eq]=" +
          this.$store.state.building +
          "&populate=deep,2"
      )
        .then((response) => response.json())
        .then((resp) => {
          console.log("Return from getRoomFloor()", resp.data);
          this.roomFloor = this.sortFloorsByName(resp.data);
          const savedFloorId = localStorage.getItem(this.getFloorStorageKey());
          const preferredFloorId = this.filter.floor || savedFloorId;
          const selectedFloor =
            this.roomFloor.find(
              (item) => String(item.id) === String(preferredFloorId)
            ) || this.roomFloor[0];
          if (selectedFloor) {
            this.filter.floor = selectedFloor.id;
            this.name_floor = selectedFloor.attributes.floorName;
            this.tab_floor = this.roomFloor.findIndex(
              (item) => String(item.id) === String(selectedFloor.id)
            );
            localStorage.setItem(
              this.getFloorStorageKey(),
              String(selectedFloor.id)
            );
          }
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลชั้น');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          this.getRentalContract();
          // loading.close()
        });
    },
    getDetailRentalContract(id) {
      const loading = this.$vs.loading();
      fetch(
        "https://api.resguru.app/api" +
          "/user-sign-contracts/" +
          id +
          "?populate=deep,3"
      )
        .then((response) => response.json())
        .then((resp) => {
          console.log("ddd", resp.data[0]?.attributes.user_sign_contract);
          this.room_detail.name =
            resp.data.attributes.users_permissions_user.data?.attributes.firstName;
          this.room_detail.last_name =
            resp.data.attributes.users_permissions_user.data?.attributes.lastName;
          this.room_detail.nick_name =
            resp.data.attributes.users_permissions_user.data?.attributes.nickName;
          this.room_detail.phone =
            resp.data.attributes.users_permissions_user.data?.attributes.phone;
          this.room_detail.id_card =
            resp.data.attributes.users_permissions_user.data?.attributes.idCard;
          this.room_detail.address =
            resp.data.attributes.users_permissions_user.data?.attributes.contactAddress;
          this.room_detail.sex =
            resp.data.attributes.users_permissions_user.data?.attributes.sex === true || resp.data.attributes.users_permissions_user.data?.attributes.sex === 1 || resp.data.attributes.users_permissions_user.data?.attributes.sex === "true";
          this.room_detail.birth =
            resp.data.attributes.users_permissions_user.data?.attributes.dateOfBirth;
          this.room_detail.date_sign = resp.data.attributes.checkInDate;
          this.room_detail.type_room =
            resp.data.attributes.room?.data?.attributes?.room_type?.data?.attributes?.roomTypeName || '';
          this.room_detail.number_room =
            resp.data.attributes.room?.data?.attributes?.RoomNumber || '';
          this.room_detail.contract_duration =
            resp.data.attributes.contractDuration;
          this.room_detail.roomInsurance_deposit =
            resp.data.attributes.roomInsuranceDeposit;
          this.room_detail.room_deposit = resp.data.attributes.roomDeposit;
          this.room_detail.exp_date = resp.data.attributes.contractEndDate || "";
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลสัญญาเช่า');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          loading.close();
          this.detail = true;
        });
    },
    getUser() {
      fetch(
        "https://api.resguru.app/api" +
          "/users?filters[room_building][id][$eq]=" +
          this.$store.state.building +
          "&populate=deep"
      )
        .then((response) => response.json())
        .then((resp) => {
          // console.log(resp);
          this.users = resp;
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลผู้ใช้');
          this.$showNotification("danger", errorMessage);
        });
    },
    getRoomType() {
      fetch(
        "https://api.resguru.app/api" +
          "/room-types?filters[roomType_building][id][$eq]=" +
          this.$store.state.building +
          "&populate=*"
      )
        .then((response) => response.json())
        .then((resp) => {
          this.room_type = resp.data;
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลประเภทห้อง');
          this.$showNotification("danger", errorMessage);
        });
    },
    getUserDetail(email) {
      if (!email) {
        this.$showNotification("warning", "กรุณากรอกอีเมลผู้เช่า");
        return;
      }
      const loading = this.$vs.loading();
      fetch(
        `https://api.resguru.app/api/users?filters[email][$eq]=${encodeURIComponent(
          email
        )}`
      )
        .then((response) => response.json())
        .then((resp) => {
          if (Array.isArray(resp) && resp.length > 0) {
            this.applyUserToForm(resp[0]);
            this.$showNotification("success", "พบผู้เช่าในระบบ");
          } else {
            this.clearFormUser();
            this.$showNotification("warning", "ไม่พบผู้เช่าที่ใช้อีเมลนี้");
          }
        })
        .catch((error) => {
          this.$showNotification(
            "danger",
            this.$errMsg(error, "ค้นหาผู้เช่า")
          );
        })
        .finally(() => {
          loading.close();
        });
    },
    create_sign(id_room, number, status, idCard, room_type, existingContract) {
      this.check_rent = status;
      this.isEditContract = false;
      this.getRoomType();
      this.create = true;
      this.create_room_number = number;
      this.id_user = "";
      this.filter.Id_card = idCard;
      this.fieldErrors = {};
      this.errorFieldMessage = "";
      this.expDateTouched = false;
      this.searchEmail = "";

      this.clearFormUser();
      this.room_detail_create.id_room = id_room;
      this.room_detail_create.water = 0;
      this.room_detail_create.ele = 0;
      this.room_detail_create.type_room = room_type;
      this.room_detail_create.check_user = true;
      this.room_detail.date_sign = "";
      this.room_detail.exp_date = "";

      // Carry over everything already captured when the room was booked in
      // "จองห้อง" (earnest -> advance rent, insurance deposit, check-in date).
      // All editable before signing.
      this.bookedEarnest = existingContract?.earnest ?? 0;
      this.room_detail_create.room_deposit = existingContract?.earnest ?? "";
      this.room_detail_create.roomInsuranceDeposit =
        existingContract?.roomInsuranceDeposit ?? "";
      this.room_detail_create.contract_duration =
        existingContract?.contractDuration
          ? String(existingContract.contractDuration)
          : "";
      this.room_detail_create.date_sign = existingContract?.checkInDate ?? "";
      this.room_detail_create.exp_date = existingContract?.contractEndDate ?? "";
      this.room_detail_create.existing_contract_id = existingContract?.id ?? "";

      // Prefill the tenant. The booking's user is already populated on
      // existingContract.users_permissions_user - use it directly so the admin
      // never has to retype the tenant's details. Fall back to an idCard lookup
      // only if that relation is missing.
      const bookedUser = existingContract?.users_permissions_user;
      if (bookedUser && bookedUser.id) {
        this.applyUserToForm(bookedUser);
      } else if (idCard) {
        fetch(
          `https://api.resguru.app/api/users?filters[idCard][$eq]=${encodeURIComponent(
            idCard
          )}`
        )
          .then((response) => response.json())
          .then((resp) => {
            if (Array.isArray(resp) && resp.length > 0) {
              this.applyUserToForm(resp[0]);
            } else {
              this.$showNotification(
                "warning",
                "ไม่พบข้อมูลผู้เช่าจากการจอง กรุณากรอกข้อมูลผู้เช่า"
              );
            }
          })
          .catch((error) => {
            this.$showNotification(
              "danger",
              this.$errMsg(error, "โหลดข้อมูลผู้เช่า")
            );
          });
      }
    },
    // Reuse the create form to EDIT the signed contract shown in the detail
    // modal. Opened from data_mock (the room-grid row). saveContractRecord()
    // already PUTs in place when existing_contract_id is set; isEditContract
    // suppresses the meter-baseline write, the deposit-income posting and the
    // "new tenant" path.
    editContract() {
      const row = this.data_mock;
      const contractId = row && row.user_sign_contract && row.user_sign_contract.id;
      if (!contractId) {
        this.$showNotification("danger", "ไม่พบสัญญาเช่าของห้องนี้");
        return;
      }
      this.check_rent = "edit";
      this.isEditContract = true;
      this.create_room_number = row.RoomNumber;
      this.id_user = "";
      this.fieldErrors = {};
      this.errorFieldMessage = "";
      this.searchEmail = "";
      // existing contract already has an end date - don't let the
      // date_sign/duration watchers recompute it out from under the admin.
      this.expDateTouched = true;

      this.getRoomType();
      this.clearFormUser();
      this.room_detail_create.check_user = true;
      this.room_detail_create.id_room = row.id;
      this.room_detail_create.type_room = row.room_type ? row.room_type.id : "";
      this.room_detail_create.existing_contract_id = contractId;
      this.room_detail_create.water = 0;
      this.room_detail_create.ele = 0;
      this.bookedEarnest = 0;

      const loading = this.$vs.loading();
      fetch(
        "https://api.resguru.app/api/user-sign-contracts/" +
          contractId +
          "?populate=deep,3"
      )
        .then((response) => response.json())
        .then((resp) => {
          const attr = (resp && resp.data && resp.data.attributes) || {};
          const user = attr.users_permissions_user && attr.users_permissions_user.data;
          if (user) {
            this.applyUserToForm({ id: user.id, ...(user.attributes || {}) });
          }
          this.room_detail_create.date_sign = attr.checkInDate || "";
          this.room_detail_create.exp_date = attr.contractEndDate || "";
          this.room_detail_create.room_deposit = attr.roomDeposit ?? "";
          this.room_detail_create.roomInsuranceDeposit =
            attr.roomInsuranceDeposit ?? "";
          this.room_detail_create.contract_duration =
            attr.contractDuration != null ? String(attr.contractDuration) : "";
          const rtId =
            attr.room &&
            attr.room.data &&
            attr.room.data.attributes &&
            attr.room.data.attributes.room_type &&
            attr.room.data.attributes.room_type.data &&
            attr.room.data.attributes.room_type.data.id;
          if (rtId) this.room_detail_create.type_room = rtId;
        })
        .catch((error) => {
          this.$showNotification(
            "danger",
            this.$errMsg(error, "โหลดข้อมูลสัญญาเช่า")
          );
        })
        .finally(() => {
          loading.close();
        });

      this.detail = false;
      this.create = true;
    },
    submitSign(a, b) {
    if (this.room_detail_create.check_user == true) {
        console.log("1");
        const loading = this.$vs.loading();
      this.syncExistingUserIfNeeded()
        .then(() =>
          this.saveContractRecord(
            this.buildContractPayload(this.room_detail_create.id)
          )
        )
            .then((resp) => {
                this.id_sign = resp.data.data.id;
                
                // FIX: Create proper user data structure
                const userDataForPDF = {
                    name: this.room_detail_create.name,
                    last_name: this.room_detail_create.last_name,
                    address: this.room_detail_create.address
                };
                
                console.log('Calling PDFPrintRental with:', {
                    contractData: a,
                    userData: userDataForPDF
                });
                
                this.PDFPrintRental(a, b, resp.data.data.id, userDataForPDF);

                return Promise.all([
                  this.updateRoomAfterContract(),
                  this.isEditContract
                    ? Promise.resolve()
                    : this.recordMoveInDepositIncome(),
                ]);
            })
            .then(() => {
                this.notifyContractSaved();
            })
            .catch((err) => {
                if (err.response?.data?.error?.message) {
                    this.openNotificationRenralPage(
                        "top-right",
                        "danger",
                        err.response?.data?.error?.message,
                        6000
                    );
                } else {
                    this.$showNotification(
                        "danger",
                        "เกิดข้อผิดพลาด ไม่สามารถบันทึกสัญญาได้"
                    );
                }
            })
            .finally(() => {
                loading.close();
                this.create = false;
                this.isEditContract = false;
                setTimeout(() => {
                    this.getRentalContract(0);
                }, 500);
            });
    } else {
        // For new user creation
        console.log("2");
        const loading = this.$vs.loading();
        axios
            .post("https://api.resguru.app/api/users", {
                username: this.room_detail_create.email,
                email: this.room_detail_create.email,
                firstName: this.room_detail_create.name,
                lastName: this.room_detail_create.last_name,
                nickName: this.room_detail_create.nick_name,
                role: 2,
                phone: this.room_detail_create.phone,
                idCard: this.room_detail_create.id_card,
                contactAddress: this.room_detail_create.address,
                dateOfBirth: this.room_detail_create.birth,
                password: this.room_detail_create.id_card,
                building: this.$store.state.building,
            })
            .then((resp) => {
                return this.saveContractRecord(
                  this.buildContractPayload(resp.data.id)
                );
            })
            .then((resp) => {
                this.id_sign = resp.data.data.id;
                
                // FIX: Create proper user data structure for new user
                const userDataForPDF = {
                    name: this.room_detail_create.name,
                    last_name: this.room_detail_create.last_name,
                    address: this.room_detail_create.address
                };
                
                this.PDFPrintRental(a, b, resp.data.data.id, userDataForPDF);

                return Promise.all([
                  this.updateRoomAfterContract(),
                  this.isEditContract
                    ? Promise.resolve()
                    : this.recordMoveInDepositIncome(),
                ]);
            })
            .then(() => {
                this.notifyContractSaved();
            })
            .catch((err) => {
                if (err.response?.data?.error?.message) {
                    this.openNotificationRenralPage(
                        "top-right",
                        "danger",
                        err.response?.data?.error?.message,
                        6000
                    );
                } else {
                    this.$showNotification(
                        "danger",
                        "เกิดข้อผิดพลาด ไม่สามารถบันทึกสัญญาได้"
                    );
                }
            })
            .finally(() => {
                loading.close();
                this.create = false;
                this.isEditContract = false;
                setTimeout(() => {
                    this.getRentalContract(0);
                }, 500);
            });
    }
},
    notifyContractSaved() {
      if (this.isEditContract) {
        this.$showNotification(
          "success",
          "แก้ไขสัญญาเช่าสำเร็จ • อัปเดตสัญญาฉบับเดิม • ออกสัญญาใหม่ (PDF)"
        );
        return;
      }
      const parts = [
        this.isFromBooking() ? "สร้างสัญญาเช่าจากการจอง" : "สร้างสัญญาเช่า",
        "อัปเดตสถานะห้องเป็น 'เข้าพักแล้ว'",
        "บันทึกเลขมิเตอร์เริ่มต้น",
        "บันทึกรายรับค่าเช่าล่วงหน้า",
        "ดาวน์โหลดสัญญา (PDF)",
      ];
      this.$showNotification("success", "ทำสัญญาเช่าสำเร็จ • " + parts.join(" • "));
    },
    filterData() {
      this.contract = this.contract.filter((item) =>
        item.RoomNumber.toLowerCase().includes(this.filter.search.toLowerCase())
      );
      if (this.filter.search == "") {
        this.getRentalContract();
      }
    },
    handleKeyDown(event) {
      // Check if the pressed key is the backspace key
      if (event.keyCode === 8) {
        this.getRentalContract(8);
        // Perform your desired action here when backspace is pressed
      }
    },
    // async PDFPrint(data) {
    //     const url = 'https://api.resguru.app/uploads/_aa6c4cb510.pdf'
    //     const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
    //     const pdfDoc = await PDFDocument.load(existingPdfBytes)
    //     pdfDoc.registerFontkit(fontkit)

    //     const url2 = 'https://docu-api-dev.clicksbiz.com/uploads/Prompt_Black_9e15c3bdf5.ttf'
    //     const ubuntuBytes = await fetch(url2).then(res => res.arrayBuffer())
    //     const font5 = await pdfDoc.embedFont(ubuntuBytes)
    //     const pages = pdfDoc.getPages()
    //     const firstPage = pages[0]
    //     const { width, height } = firstPage.getSize()
    //     firstPage.drawText(this.$store.state.buildingInfo[0].attributes.buildingName, {
    //         x: 201,
    //         y: 815 / 2 + 300,
    //         size: 10,
    //         font: font5,
    //         color: rgb(0,0,0),
    //         rotate: degrees(-0),
    //     })
    //     firstPage.drawText(convertDateNoTime(data.createdAt), {
    //         x: 320,
    //         y: 815 / 2 + 300,
    //         size: 10,
    //         font: font5,
    //         color: rgb(0,0,0),
    //         rotate: degrees(-0),
    //     })
    //     firstPage.drawText(this.$store.state.buildingInfo[0].attributes.buildingName+' '+'และ'+' '+data.user_sign_contract.users_permissions_user.firstName +' '+data.user_sign_contract.users_permissions_user.lastName, {
    //         x: 95,
    //         y: 771 / 2 + 300,
    //         size: 10,
    //         font: font5,
    //         color: rgb(0,0,0),
    //         rotate: degrees(-0),
    //     })
    //     firstPage.drawText(data.user_sign_contract.users_permissions_user.contactAddress, {
    //         x: 306,
    //         y: 771 / 2 + 300,
    //         size: 10,
    //         font: font5,
    //         color: rgb(0,0,0),
    //         rotate: degrees(-0),
    //     })
    //     firstPage.drawText(data.user_sign_contract.users_permissions_user.district, {
    //         x: 95,
    //         y: 727 / 2 + 300,
    //         size: 10,
    //         font: font5,
    //         color: rgb(0,0,0),
    //         rotate: degrees(-0),
    //     })
    //     firstPage.drawText(data.user_sign_contract.users_permissions_user.subDistrict, {
    //         x: 250,
    //         y: 727 / 2 + 300,
    //         size: 10,
    //         font: font5,
    //         color: rgb(0,0,0),
    //         rotate: degrees(-0),
    //     })
    //     firstPage.drawText(data.user_sign_contract.users_permissions_user.province, {
    //         x: 380,
    //         y: 727 / 2 + 300,
    //         size: 10,
    //         font: font5,
    //         color: rgb(0,0,0),
    //         rotate: degrees(-0),
    //     })
    //     firstPage.drawText(data.user_sign_contract.users_permissions_user.firstName +' '+data.user_sign_contract.users_permissions_user.lastName, {
    //         x: 265,
    //         y: 683 / 2 + 300,
    //         size: 10,
    //         font: font5,
    //         color: rgb(0,0,0),
    //         rotate: degrees(-0),
    //     })
    //     firstPage.drawText(data.user_sign_contract.users_permissions_user.firstName +' '+data.user_sign_contract.users_permissions_user.lastName, {
    //         x: 265,
    //         y: 683 / 2 + 300,
    //         size: 10,
    //         font: font5,
    //         color: rgb(0,0,0),
    //         rotate: degrees(-0),
    //     })
    //     const pdfBytes = await pdfDoc.save()
    //     const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
    //     const pdfUrl = URL.createObjectURL(pdfBlob);
    //     window.open(pdfUrl, '_blank');
    // },
  },
};
</script>
<style>
.text-custom {
  font-family: "Prompt";
}

#mr {
  width: 90px;
}

/* .vs-select__input{
    height: 36px !important;
    width: 350px !important;
} */
.table-container {
  width: 100%;
  /* Set a fixed height to enable scrolling */
  overflow-y: scroll;
  padding: 8px;
  /* Enable vertical scrolling */
  /* Optional: Add padding for spacing */
}
</style>
